var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInbound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.89,
    height: 22.988,
    viewBox: "0 0 35.89 22.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25280",
    "data-name": "Group 25280",
    transform: "translate(-3376.791 -10827.116)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_560",
    "data-name": "Line 560",
    x2: 34.89,
    transform: "translate(3377.291 10849.604)",
    fill: "none",
    stroke: "#0b2055",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12656",
    "data-name": "Path 12656",
    d: "M144.1,18.339l-4.048-.737a.371.371,0,0,1-.248-.56l4.295-4.653L134.14,10.54l-2.069-.134-1.045-1.193L132.1,7.66l-.649-4.638a.372.372,0,0,1,.13-.3.363.363,0,0,1,.319-.079l2.919.654a.37.37,0,0,1,.28.27l.886,3.445,8.97,1.385-2.561-6.689a.371.371,0,0,1,.427-.451L146,1.834a.374.374,0,0,1,.254.179l6.027,7.414,3.979.955c5.374,1.373,6.851,3.312,6.637,4.486-.319,1.754-4.806,1.009-8.478.4,0,0-1.763-.289-2.686-.448,0,0-7.262,3.383-7.315,3.431A.371.371,0,0,1,144.1,18.339Z",
    transform: "translate(3247.521 10826.369)",
    fill: "none",
    stroke: "#0b2055",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_561",
    "data-name": "Line 561",
    x1: 4.403,
    y1: 0.802,
    transform: "translate(3395.395 10834.994)",
    fill: "none",
    stroke: "#0b2055",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbound);
export default __webpack_public_path__ + "static/media/inbound.900ff746805357d48f23ae3517b5b855.svg";
export { ForwardRef as ReactComponent };